import { useSearchParams } from "react-router";

import Valkyrie, { viFilterXmark } from "@sippy-platform/valkyrie";

import { Button, Tooltip } from "@mui/material";

export default function ClearFilterAction({ onClick, disabled }: { onClick: () => void; disabled: boolean }) {
  const [, setSearchParams] = useSearchParams();

  function resetFilters() {
    if (onClick) onClick();
    setSearchParams({});
  }

  return (
    <Tooltip title="Clear filters">
      <span>
        <Button
          variant={disabled ? "contained" : undefined}
          color={disabled ? undefined : "inherit"}
          disabled={!disabled}
          id="action-reset"
          onClick={resetFilters}
          sx={{ fontSize: "1rem", px: 1.25 }}
        >
          <Valkyrie icon={viFilterXmark} />
        </Button>
      </span>
    </Tooltip>
  );
}
